export default __webpack_public_path__ + "static/media/1.0b3cce4c.jpg";